import { IconTrophy } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const LeaderboardsPage = lazy(() => import("./LeaderboardsPage").then((m) => ({ default: m.LeaderboardsPage })));

export const routes: FeatureRoute[] = [
  {
    path: "/admin/leaderboards",
    roles: CAPS.admin.leaderboards,
    element: createElement(Suspense, { fallback: null }, createElement(LeaderboardsPage)),
  },
];

export const nav: NavItem[] = [
  {
    label: "Leaderboards",
    path: "/admin/leaderboards",
    icon: IconTrophy,
    surface: "admin",
    roles: CAPS.admin.leaderboards,
  },
];
